import { AbstractControl, ValidationErrors } from '@angular/forms';

export function minOneChecked(
  control: AbstractControl,
): ValidationErrors | null {
  const formArray = control.value as boolean[];
  return formArray.some((v) => v) ? null : { required: true };
}
